/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of resource to subscribe to.
 * @export
 */
export const SubscriptionResourceType = {
    Activity: 'Activity',
    Consignment: 'Consignment',
    CustomerOrder: 'CustomerOrder',
    InvoicingDocument: 'InvoicingDocument',
    Item: 'Item',
    Piece: 'Piece',
    Product: 'Product',
    Quotation: 'Quotation',
    QuotationRequest: 'QuotationRequest',
    HumanMean: 'HumanMean',
    MaterialMean: 'MaterialMean',
    Service: 'Service',
    ServiceRequest: 'ServiceRequest'
} as const;
export type SubscriptionResourceType = typeof SubscriptionResourceType[keyof typeof SubscriptionResourceType];


export function instanceOfSubscriptionResourceType(value: any): boolean {
    for (const key in SubscriptionResourceType) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionResourceType, key)) {
            if (SubscriptionResourceType[key as keyof typeof SubscriptionResourceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionResourceTypeFromJSON(json: any): SubscriptionResourceType {
    return SubscriptionResourceTypeFromJSONTyped(json, false);
}

export function SubscriptionResourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionResourceType {
    return json as SubscriptionResourceType;
}

export function SubscriptionResourceTypeToJSON(value?: SubscriptionResourceType | null): any {
    return value as any;
}

export function SubscriptionResourceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionResourceType {
    return value as SubscriptionResourceType;
}

